import { GDSSelectProps } from '@leagueplatform/genesis-core';

export const getSelectOptionsWithPlaceholder = ({
  enumOptions,
  enumPlaceholder,
}: {
  enumOptions?: GDSSelectProps['options'];
  enumPlaceholder?: string;
}) => {
  if (enumOptions) {
    return { options: [{ value: '', label: enumPlaceholder }, ...enumOptions] };
  }
  return { placeholder: enumPlaceholder, options: enumOptions };
};
